<div class="wrapper" title="{{info}}">
  <div
    class="button-wrapper {{ disable ? 'disable' : 'non-disable' }} {{
      primary ? 'primary' : 'secondary'
    }} {{ big ? 'big' : 'normal' }}"
    (click)="onClick()"
  >
    <i *ngIf="icon" [className]="title ? 'space fa '+ icon  : 'fa '+ icon "></i>{{ title }}
  </div>
</div>
